export enum PeerConnectionId {
    Audio = 'audio',
    AudioVideo = 'audio_video',
    ScreenSharing = 'screen_sharing'
}